import {Component, Input, OnInit} from '@angular/core';
import {PermissionsService} from '../../../Services/permissions.service';
import {DataService} from '../../../Services/data.service';
import {StorageService} from '../../../Services/storage.service';
import {DatePipe} from '@angular/common';
import {CustomFilterPipe} from '../../common/custom-filter.pipe';
import {Router} from '@angular/router';
import {EncrDecrService} from '../../../Services/encr-decr.service';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-home-quick-navigation',
  templateUrl: './home-quick-navigation.component.html',
  styleUrls: ['./home-quick-navigation.component.css'],
  standalone: false
})
export class HomeQuickNavigationComponent implements OnInit {
  @Input() vm: any;
  permissionsAdmin = true;

  constructor(public p: PermissionsService,
              public tableDataService: DataService,
              public localStorage: StorageService,
              public datePipe: DatePipe,
              public cFilter: CustomFilterPipe,
              private router: Router,
              private encryptDecrypt: EncrDecrService,
              private titleService: Title
  ) {
  }

  ngOnInit() {
    this.titleService.setTitle($localize`:Quick Navigation@@quickNavigation:Quick Navigation`);
    this.getInfo();
    const x = this.localStorage.StorageGet('Permissions');
    this.p.LoadPermissions(JSON.parse(x), 'home nav');
  }

  getInfo() {

    if (this.localStorage.StorageGet('location')) {
      this.vm.location = JSON.parse(this.localStorage.StorageGet('location'));
    } else {
      this.tableDataService.getData('location?state=active').subscribe((locationResult: any[]) => {
        this.vm.location = locationResult;
        this.localStorage.StorageSet('location', JSON.stringify(locationResult));
      });
    }
  }

  encodeQueryData(data) {
    const ret = [];
    for (const d in data) {
      if (data[d] != null && data[d] != '') {
        ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
      } else if (data[d] != null && data[d] == '') {
        ret.push(encodeURIComponent(d) + '=');
      }
    }
    return ret.join('&');
  }
}
